// تسميات تبويب التسويات + مخالصة نهاية الخدمة (ثنائية اللغة؛ تُحقن أيضاً في نافذة الطباعة).
export const REASONS = ["termination", "resignation", "contract_end", "other"];

export const S = {
  ar: {
    title: "التسويات",
    saved: "التسويات المحفوظة",
    empty: "لا توجد تسويات محفوظة بعد",
    hint: "اختر موظفاً منتهية خدمته لعرض تسويته وحسابها.",
    pickEmployee: "اختر موظفاً منتهية خدمته",
    done: "مُسوّاة",
    save: "حفظ وطباعة",
    print: "طباعة المخالصة",
    close: "إغلاق",
    pdfTitle: "مخالصة نهاية الخدمة",
    generatedAt: "تاريخ الإصدار",
    reasons: { termination: "إنهاء خدمات", resignation: "استقالة", contract_end: "نهاية عقد", other: "أخرى" },
    exitTypes: { termination: "إنهاء خدمات", dismissal: "فصل", resignation: "استقالة", contract_end: "نهاية عقد", other: "أخرى" },
    legalTitle: "مفصول — إجراءات قانونية",
    legalNote: "تم فصل هذا الموظف. لا تُحتسب له أي تسوية نهائية، والحالة محوّلة إلى الإجراءات القانونية.",
    ident: { name: "الموظف", job: "المسمى الوظيفي", branch: "الفرع", basic: "الراتب الأساسي", reason: "سبب إنهاء الخدمة" },
    rows: {
      basic: "الراتب الأساسي", hire: "تاريخ المباشرة", last: "آخر يوم عمل", years: "مدة الخدمة (سنوات)",
      accrued: "الراتب المستحق حتى آخر يوم عمل", gratuity: "مكافأة نهاية الخدمة",
      deductions: "الخصومات (السلف القائمة)", net: "صافي المخالصة النهائية",
    },
    hints: {
      accrued: "= (الراتب الأساسي ÷ 30) × أيام العمل حتى آخر يوم في الشهر",
      gratuity: "نصف راتب أساسي عن كل سنة لأول 3 سنوات، وراتب كامل عن كل سنة بعدها",
      deductions: "رصيد أقساط السلف القائمة غير المخصومة (قابل للتعديل)",
    },
    gratuityNote: "طريقة احتساب مكافأة نهاية الخدمة: نصف راتب أساسي عن كل سنة من السنوات الثلاث الأولى، وراتب أساسي كامل عن كل سنة بعدها، محسوبة من تاريخ المباشرة حتى آخر يوم عمل. صافي المخالصة = الراتب المستحق + المكافأة − الخصومات.",
    listCols: ["الموظف", "الفرع", "السبب", "آخر يوم عمل", "سنوات الخدمة", "صافي المخالصة"],
    signRoles: ["إقرار الموظف", "اعتماد الموارد البشرية", "اعتماد المدير العام"],
  },
  en: {
    title: "Settlements",
    saved: "Saved settlements",
    empty: "No saved settlements yet",
    hint: "Pick a terminated employee to compute their final settlement.",
    pickEmployee: "Pick a terminated employee",
    done: "Settled",
    save: "Save & print",
    print: "Print settlement",
    close: "Close",
    pdfTitle: "End-of-Service Settlement",
    generatedAt: "Issued on",
    reasons: { termination: "Termination", resignation: "Resignation", contract_end: "Contract end", other: "Other" },
    exitTypes: { termination: "Termination", dismissal: "Dismissal", resignation: "Resignation", contract_end: "Contract end", other: "Other" },
    legalTitle: "Dismissed — legal action",
    legalNote: "This employee was dismissed. No final settlement is due, and the case is referred to legal action.",
    ident: { name: "Employee", job: "Job title", branch: "Branch", basic: "Basic salary", reason: "Reason for leaving" },
    rows: {
      basic: "Basic salary", hire: "Hire date", last: "Last working day", years: "Years of service",
      accrued: "Salary accrued to last working day", gratuity: "End-of-service gratuity",
      deductions: "Deductions (outstanding advances)", net: "Final net settlement",
    },
    hints: {
      accrued: "= (basic salary ÷ 30) × worked days up to the last day of the month",
      gratuity: "Half a basic salary per year for the first 3 years, a full salary per year after",
      deductions: "Outstanding advance instalments not yet deducted (editable)",
    },
    gratuityNote: "End-of-service gratuity: half a basic salary per year for the first three years and a full basic salary per year thereafter, computed from hire date to last working day. Net settlement = accrued salary + gratuity − deductions.",
    listCols: ["Employee", "Branch", "Reason", "Last working day", "Years", "Net settlement"],
    signRoles: ["Employee acknowledgement", "HR approval", "General manager approval"],
  },
};
